/* Component Fix Co — collection page: size bar, facets, sort, grid / spec table, add to basket */
(function () {
  'use strict';
  var root = document.getElementById('cf-collection');
  var dataEl = document.getElementById('cf-col-data');
  if (!root || !dataEl) return;
  var RAW;
  try { RAW = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var COL = window.CF_COL || {};
  var FAM = root.getAttribute('data-fam');
  var IS_DEPT = root.getAttribute('data-dept') === 'true';
  var PAGE = parseInt(root.getAttribute('data-page'), 10) || 18;
  var ROOT_URL = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- helpers ---------- */
  function $(s, el) { return (el || root).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) {
    var f = window.CF_MONEY || '£{{amount}}';
    var parts = (c / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return parts[0];
      if (k === 'amount_with_comma_separator') return parts[0].replace(/,/g, '.') + ',' + parts[1];
      return parts.join('.');
    }).replace(/<[^>]*>/g, '');
  }
  function num(n) { return String(+(+n).toFixed(2)); }
  var FR = { 0.5: '½', 0.25: '¼', 0.75: '¾' };
  function inch(z) { var w = Math.floor(z), f = +(z - w).toFixed(2); return (w ? w : '') + (f ? (FR[f] || '.' + String(f).slice(2)) : '') + '"'; }
  var EQ = { 0.5: 15, 0.75: 20, 1: 25, 1.25: 32, 1.5: 40, 2: 50, 2.5: 65, 3: 80, 4: 100, 5: 125, 6: 150, 8: 200, 10: 250, 12: 300, 14: 350, 16: 400, 18: 450, 20: 500, 24: 600, 30: 750, 36: 900 };
  var DN2IN = {}; Object.keys(EQ).forEach(function (k) { DN2IN[EQ[k]] = +k; });
  var COLS = 'Black|White|Yellow|Red|Green|Blue|Brown|Grey|Orange|Purple|Silver|Clear';
  var COL_RE = new RegExp('\\b((?:' + COLS + ')(?:\\s*&\\s*(?:' + COLS + '))?)\\b');
  var DOT = { Black: '#14181D', White: '#FFFFFF', Yellow: '#FFC21A', Red: '#C8302B', Green: '#2E8B3E', Blue: '#1E5BC6', Brown: '#7A4B2A', Grey: '#8A929A', Orange: '#F07C1B', Purple: '#7B4BB8', Silver: '#C0C4C8', Clear: '#EEF3F6' };
  var BANDS = [['u5', 'Under £5', 0, 500], ['5-20', '£5 – £20', 500, 2000], ['20-50', '£20 – £50', 2000, 5000], ['50+', '£50 and over', 5000, 1e12]];
  function bandOf(p) { for (var i = 0; i < BANDS.length; i++) if (p >= BANDS[i][2] && p < BANDS[i][3]) return BANDS[i][0]; return ''; }

  /* ---------- kinds ---------- */
  var TAPE = {
    'PVC Electrical Insulation Tape': 'elec', 'Self Amalgamating EPR Tape': 'elec', 'Self Amalgamating PVC Tape': 'elec', 'Self Amalgamating Silicone Tape': 'elec',
    'Low Tack Masking Tape': 'mask', 'UV Resistant Blue Masking Tape': 'mask', 'Gaffer Tape': 'gaff', 'Fleece Tape': 'gaff',
    'Floor Marking Tape': 'floor', 'Safety Hazard Warning Tape': 'floor', 'Non-Adhesive Barrier Tape': 'floor', 'Underground Cable Warning Tape': 'floor', 'Non Slip Tape': 'floor',
    'Double Sided Foam Tape': 'mount', 'PTFE Tape': 'mount', 'Packing Tape': 'mount', 'Fragile Tape': 'mount'
  };
  var KIND = {
    s: { l: 'Stud hole insert', sub: 'stud-hole-inserts', fam: 'flange' },
    d: { l: 'Self-adhesive disc', sub: 'self-adhesive-flange-discs', fam: 'flange' },
    c: { l: 'Cover cap', sub: 'flange-cover-caps', fam: 'flange' },
    f: { l: 'Full face protector', sub: 'full-face-flange-protectors', fam: 'flange' },
    u: { l: 'U-profile', sub: 'u-profile-edge-protectors', fam: 'edge' },
    sq: { l: 'Square edge protector', sub: 'square-edge-protectors', fam: 'edge' },
    grip: { l: 'Steel-reinforced grip', sub: 'steel-reinforced-grip-trims', fam: 'edge' },
    lip: { l: 'Side-lip door seal', sub: 'side-lip-door-seals', fam: 'edge' },
    foam: { l: 'Foam strip', sub: 'self-adhesive-foam-strips', fam: 'edge' },
    elec: { l: 'Electrical & insulation', sub: 'electrical-insulation-tapes', fam: 'tape' },
    mask: { l: 'Masking', sub: 'masking-tapes', fam: 'tape' },
    gaff: { l: 'Gaffer & cloth', sub: 'gaffer-cloth-tapes', fam: 'tape' },
    floor: { l: 'Floor marking & warning', sub: 'floor-marking-warning-tapes', fam: 'tape' },
    mount: { l: 'Mounting, sealing & packing', sub: 'mounting-sealing-packing-tapes', fam: 'tape' }
  };
  var SUB2KIND = {}; Object.keys(KIND).forEach(function (k) { SUB2KIND[KIND[k].sub] = k; });
  var DEPT_FAM = { 'flange-protection': 'flange', 'edge-trims-seals': 'edge', 'industrial-tapes': 'tape' };

  function kindOf(type, t) {
    switch (type) {
      case 'Flange Stud Hole Insert': return 's';
      case 'ANSI Adhesive Flange Discs': case 'DIN Adhesive Flange Discs': return 'd';
      case 'Flange Cover Caps': case 'Pipe & Flange Protection': return 'c';
      case 'Full Face Flange Protector': case 'DIN Flange Protectors': return 'f';
      case 'Edge Trims': return /^U-Profile/i.test(t) ? 'u' : 'sq';
      case 'Reinforced Edge Trim': return 'grip';
      case 'Door Seals': return 'lip';
      case 'Self Adhesive Edging Strips': return 'foam';
    }
    return TAPE[type] || '';
  }

  /* ---------- parse every product ---------- */
  function parse(r, i) {
    var x = { i: i, t: r[0], type: r[1], id: r[2], p: r[3], a: r[4], u: r[5], img: r[6] };
    x.k = kindOf(x.type, x.t);
    x.fam = x.k ? KIND[x.k].fam : 'other';
    x.kindL = x.k ? KIND[x.k].l : (x.type || 'Part');
    var t = x.t;
    var cm = t.match(COL_RE); x.col = cm ? cm[1].split(/\s*&\s*/).sort().join(' & ') : '';
    x.band = bandOf(x.p);
    x.spec = []; x.tbl = []; x.badge = ''; x.sort = 0; x.sort2 = 0; x.mat = '';
    if (x.fam === 'flange') {
      var tt = t.replace(/(\d)?([½¼¾])/g, function (m, d, f) { return (d ? d + '-' : '') + { '½': '1/2', '¼': '1/4', '¾': '3/4' }[f]; });
      var m = tt.match(/\bDN\s?(\d+)/);
      if (m) { x.std = 'DIN'; x.sz = +m[1]; }
      else {
        m = tt.match(/(?:^|[\s,])((\d+)-(\d+)\/(\d+)|(\d+)\/(\d+)|(\d+(?:\.\d+)?))\s?"/);
        if (m) { x.std = 'ANSI'; x.sz = m[2] ? +m[2] + m[3] / m[4] : (m[5] ? m[5] / m[6] : +m[7]); }
      }
      x.dn = x.std === 'DIN' ? x.sz : (EQ[x.sz] || x.sz * 25);
      x.sizeL = x.std === 'DIN' ? 'DN ' + x.sz : (x.sz ? inch(x.sz) : '');
      var cl = tt.match(/Class\s?([\d\/]+)/), pn = tt.match(/PN\s?\d+/);
      x.cls = cl ? cl[1] : (pn ? pn[0].replace(/\s+/, ' ') : '');
      x.mat = /Polycor/.test(t) ? 'Polycor' : /LDPE/.test(t) ? 'LDPE' : /Polyethylene/.test(t) ? 'Polyethylene' : /Neoprene/.test(t) ? 'Neoprene' : ({ d: 'Neoprene', c: 'Polyethylene', s: 'LDPE', f: 'LDPE' }[x.k] || '');
      var dm = tt.match(/([\d.]+)\s?mm( ID| OD| Head)?/);
      var fits = x.std === 'ANSI' ? (EQ[x.sz] ? 'DN ' + EQ[x.sz] : 'ANSI') : (DN2IN[x.sz] ? inch(DN2IN[x.sz]) + ' NPS' : 'DIN / EN');
      var dimK = x.k === 'c' ? 'Cap ID' : x.k === 'd' ? 'Disc Ø' : (dm && dm[2] === ' Head' ? 'Head Ø' : 'Outer Ø');
      var dim = dm ? num(dm[1]) + ' mm' : '—';
      if (x.k === 's') x.spec = [['Fits', 'Bolt holes'], ['Class', x.cls + (x.col ? ' · ' + x.col : '')], ['Material', x.mat]];
      else if (x.k === 'f') x.spec = [[dimK, dim], [x.cls ? 'Rating' : 'Colour', x.cls ? x.cls + (x.col ? ' · ' + x.col : '') : x.col], ['Material', x.mat]];
      else x.spec = [[dimK, dim], ['Fits', fits], ['Material', x.mat]];
      x.tbl = [x.k === 's' ? 'Bolt holes' : dim, x.k === 's' || x.cls ? x.cls + (x.col ? ' · ' + x.col : '') : (x.col || fits), x.mat];
      x.badge = x.sizeL; x.sort = x.dn; x.sub2 = x.std === 'ANSI' ? 'ANSI / ASME' : 'DIN / EN';
    } else if (x.k === 'foam') {
      var fm = t.match(/(\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)mm/);
      x.w = fm ? +fm[1] : 0; x.th = fm ? +fm[2] : 0;
      var rl = t.match(/(\d+)m Roll/i); x.len = rl ? +rl[1] : 0;
      x.mat = /Silicone/i.test(t) ? 'Silicone foam' : /EPDM/i.test(t) ? 'EPDM foam' : 'Foam';
      x.spec = [['Size', x.w + ' × ' + x.th + ' mm'], ['Roll', x.len ? x.len + ' m' : '—'], ['Material', x.mat]];
      x.tbl = [x.w + ' × ' + x.th + ' mm', 'Flat faces', x.len ? x.len + ' m' : '—'];
      x.badge = x.th + ' mm thick'; x.sort = x.th; x.sort2 = x.w; x.sub2 = x.mat;
    } else if (x.fam === 'edge') {
      var em = t.match(/([\d.]+x[\d.]+mm) for ([\d.]+)(?:-([\d.]+))?mm Panels\s*[-–]\s*(\d+)m\s+(\w+)/i);
      if (em) { x.sec = em[1]; x.pa = +em[2]; x.pb = +(em[3] || em[2]); x.len = +em[4]; x.mat = em[5].toUpperCase() === 'PVC' ? 'PVC' : 'EPDM'; }
      var rng = em ? (x.pa === x.pb ? num(x.pa) + ' mm' : num(x.pa) + '–' + num(x.pb) + ' mm') : '—';
      x.spec = [['Section', x.sec || '—'], ['Panel', rng], ['Length', x.len ? x.len + ' m' : '—']];
      x.tbl = [x.sec || '—', rng, x.len ? x.len + ' m' : '—'];
      x.badge = rng; x.sort = x.pa || 0; x.sort2 = x.len || 0; x.sub2 = x.mat;
    } else if (x.fam === 'tape') {
      var wm = t.match(/^(\d+(?:\.\d+)?)\s?mm/); x.w = wm ? +wm[1] : 0;
      var lm = t.match(/(\d+)\s?m\s*$/); x.len = lm ? +lm[1] : 0;
      x.spec = [['Width', x.w ? x.w + ' mm' : '—'], ['Roll', x.len ? x.len + ' m' : '—'], ['Colour', x.col || '—']];
      x.tbl = [x.w ? x.w + ' mm' : '—', x.len ? x.len + ' m' : '—', x.col || '—'];
      x.badge = x.w ? x.w + ' mm' : ''; x.sort = x.w; x.sort2 = x.len; x.sub2 = x.type;
    } else {
      x.spec = []; x.tbl = ['—', '—', '—']; x.sub2 = '';
    }
    return x;
  }

  var P = [];
  function build() { P = RAW.map(parse); }
  build();

  /* ---------- which mode for this page ---------- */
  var fams = {}; P.forEach(function (x) { fams[x.fam] = 1; });
  var mode = FAM !== 'all' ? FAM : (Object.keys(fams).length === 1 ? Object.keys(fams)[0] : 'all');
  var allFoam = P.length && P.every(function (x) { return x.k === 'foam'; });
  var BAR = null;
  if (mode === 'flange') BAR = { title: 'Your flange', hint: 'Stamped on the flange rim', type: 'flange' };
  else if (mode === 'edge' && allFoam) BAR = { title: 'Foam thickness', hint: 'In millimetres', type: 'foamth' };
  else if (mode === 'edge') BAR = { title: 'Your panel (mm)', hint: 'Measure the edge with a caliper', type: 'panel' };
  else if (mode === 'tape') BAR = { title: 'Tape width (mm)', hint: 'Across the roll', type: 'width' };
  var UNIT = { flange: ['protector', 'protectors'], edge: allFoam ? ['strip', 'strips'] : ['trim', 'trims'], tape: ['tape', 'tapes'] }[mode] || ['part', 'parts'];
  var TBL_H = { flange: ['Dimension', 'Class / colour', 'Material'], edge: allFoam ? ['Size', 'Use', 'Roll'] : ['Section', 'Panel', 'Length'], tape: ['Width', 'Roll', 'Colour'] }[mode] || ['', '', ''];

  /* ---------- state ---------- */
  var S = { kind: '', std: '', size: 0, f: { cls: {}, mat: {}, col: {}, len: {}, band: {} }, sort: 'size', view: 'grid', shown: PAGE, side: false, q: {} };
  if (IS_DEPT) { var hk = (location.hash.match(/type=([\w-]+)/) || [])[1]; if (hk && SUB2KIND[hk]) S.kind = SUB2KIND[hk]; }

  function has(o) { return Object.keys(o).length > 0; }
  function sizeMatch(x) {
    if (!BAR || !S.size) return true;
    if (BAR.type === 'flange') return x.std === S.std && x.sz === S.size;
    if (BAR.type === 'panel') return x.k !== 'foam' && x.pa <= S.size && S.size <= x.pb;
    if (BAR.type === 'foamth') return x.th === S.size;
    if (BAR.type === 'width') return x.w === S.size;
    return true;
  }
  function pass(x, skip) {
    if (skip !== 'kind' && S.kind && x.k !== S.kind) return false;
    if (skip !== 'std' && BAR && BAR.type === 'flange' && S.std && x.std !== S.std) return false;
    if (skip !== 'size' && !sizeMatch(x)) return false;
    var keys = ['cls', 'mat', 'col', 'len', 'band'];
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (skip === k || !has(S.f[k])) continue;
      if (!S.f[k][String(x[k])]) return false;
    }
    return true;
  }

  /* ---------- facets definition ---------- */
  function facetDefs() {
    var d = [];
    if (mode === 'flange') d.push({ k: 'cls', title: 'Pressure class', hint: 'Must match the class stamped on the flange', lab: function (v) { return /^PN/.test(v) ? v : 'Class ' + v; }, order: function (a, b) { function o(v) { return /^PN/.test(v) ? 1e4 + parseInt(v.replace(/\D/g, ''), 10) : parseInt(v, 10) + (v.indexOf('/') > -1 ? 0.5 : 0); } return o(a) - o(b); } });
    if (mode !== 'tape') d.push({ k: 'mat', title: 'Material' });
    d.push({ k: 'col', title: 'Colour' });
    if (mode !== 'flange') d.push({ k: 'len', title: mode === 'tape' ? 'Roll length' : 'Length', lab: function (v) { return v + ' m'; }, order: function (a, b) { return a - b; } });
    d.push({ k: 'band', title: 'Price', lab: function (v) { for (var i = 0; i < BANDS.length; i++) if (BANDS[i][0] === v) return BANDS[i][1]; return v; }, order: function (a, b) { var o = BANDS.map(function (z) { return z[0]; }); return o.indexOf(a) - o.indexOf(b); } });
    return d;
  }
  var FD = facetDefs();
  FD.forEach(function (f) {
    var vals = {}; P.forEach(function (x) { var v = x[f.k]; if (v !== '' && v != null && v !== 0) vals[String(v)] = 1; });
    f.vals = Object.keys(vals).sort(f.order || function (a, b) { return a.localeCompare(b); });
  });
  FD = FD.filter(function (f) { return f.vals.length > 1; });

  /* ---------- render pieces ---------- */
  function renderBar() {
    var bar = $('[data-sizebar]');
    if (!BAR) { bar.hidden = true; return; }
    var base = P.filter(function (x) { return pass(x, 'size'); });
    var vals = {};
    if (BAR.type === 'flange') { base.forEach(function (x) { if (S.std && x.std === S.std && x.sz) vals[x.sz] = 1; }); }
    else if (BAR.type === 'panel') { P.forEach(function (x) { if (x.pa) { vals[x.pa] = 1; vals[x.pb] = 1; } }); }
    else if (BAR.type === 'foamth') { P.forEach(function (x) { if (x.th) vals[x.th] = 1; }); }
    else { P.forEach(function (x) { if (x.w) vals[x.w] = 1; }); }
    var list = Object.keys(vals).map(Number).sort(function (a, b) { return a - b; });
    if (BAR.type !== 'flange' && list.length < 2) { bar.hidden = true; return; }
    bar.hidden = false;
    $('[data-bar-title]').textContent = BAR.title;
    $('[data-bar-hint]').textContent = BAR.hint;
    var seg = $('[data-stds]');
    if (BAR.type === 'flange') {
      var stds = {}; P.forEach(function (x) { if (x.std) stds[x.std] = 1; });
      var opts = [['', 'Any']].concat([['ANSI', 'ANSI / ASME'], ['DIN', 'DIN / EN']].filter(function (o) { return stds[o[0]]; }));
      if (opts.length === 2 && !S.std) { S.std = opts[1][0]; return renderBar(); }
      seg.hidden = opts.length < 3;
      seg.innerHTML = opts.map(function (o) { var on = S.std === o[0]; return '<button type="button" class="seg' + (on ? ' on' : '') + '" aria-pressed="' + on + '" data-std="' + o[0] + '">' + o[1] + '</button>'; }).join('');
    } else seg.hidden = true;
    var sz = $('[data-sizes]');
    if (BAR.type === 'flange' && !S.std) sz.innerHTML = '<p class="cfc__barmsg">Pick ANSI or DIN to choose a nominal size.</p>';
    else sz.innerHTML = list.map(function (v) {
      var l = BAR.type === 'flange' ? (S.std === 'DIN' ? 'DN ' + v : inch(v)) : num(v);
      var on = S.size === v;
      return '<button type="button" class="chd' + (on ? ' on' : '') + '" aria-pressed="' + on + '" data-size="' + v + '">' + l + '</button>';
    }).join('');
    var eq = $('[data-eq]'), txt = '';
    if (S.size) {
      if (BAR.type === 'flange') txt = S.std === 'ANSI' ? inch(S.size) + ' ≈ DN ' + (EQ[S.size] || '?') : 'DN ' + S.size + (DN2IN[S.size] ? ' ≈ ' + inch(DN2IN[S.size]) + ' NPS' : '');
      else if (BAR.type === 'panel') txt = 'Trims that grip a ' + num(S.size) + ' mm edge';
    }
    eq.hidden = !txt; eq.textContent = txt;
  }

  function renderFacets() {
    $('[data-facets]').innerHTML = FD.map(function (f) {
      var base = P.filter(function (x) { return pass(x, f.k); });
      return '<div class="cfc__fbox"><h3>' + esc(f.title) + '</h3>' + (f.hint ? '<p class="cfc__fh">' + esc(f.hint) + '</p>' : '') +
        f.vals.map(function (v) {
          var n = base.filter(function (x) { return String(x[f.k]) === v; }).length;
          var on = !!S.f[f.k][v];
          var lab = f.lab ? f.lab(v) : v;
          var dot = f.k === 'col' ? '<span class="cfc__dot" style="' + dotStyle(v) + '"></span>' : '';
          return '<button type="button" class="cfc__opt' + (on ? ' on' : '') + (!n && !on ? ' dis' : '') + '" aria-pressed="' + on + '" data-fk="' + f.k + '" data-fv="' + esc(v) + '"><span class="bx"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#FFC21A" stroke-width="3.2" stroke-linecap="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg></span>' + dot + esc(lab) + '<span class="n">' + n + '</span></button>';
        }).join('') + '</div>';
    }).join('');
  }
  function dotStyle(c) {
    var p = String(c).split(' & ');
    var a = DOT[p[0]] || '#fff', b = DOT[p[1]] || a;
    return 'background:' + (p.length > 1 ? 'linear-gradient(90deg,' + a + ' 50%,' + b + ' 50%)' : a);
  }

  function chips() {
    var c = [];
    if (S.kind) c.push(['kind', '', KIND[S.kind].l]);
    if (BAR && BAR.type === 'flange' && S.std) c.push(['std', '', S.std === 'ANSI' ? 'ANSI / ASME' : 'DIN / EN']);
    if (S.size) c.push(['size', '', BAR.type === 'flange' ? (S.std === 'DIN' ? 'DN ' + S.size : inch(S.size)) : num(S.size) + ' mm']);
    FD.forEach(function (f) { Object.keys(S.f[f.k]).forEach(function (v) { c.push([f.k, v, f.lab ? f.lab(v) : v]); }); });
    return c;
  }

  function card(x) {
    var q = S.q[x.i] || 1;
    return '<article class="cfc__card">' +
      '<a class="cfc__img" href="' + esc(x.u) + '" tabindex="-1" aria-hidden="true">' + (x.img ? '<img src="' + esc(x.img) + '" alt="" loading="lazy" width="600" height="600">' : '') +
      (x.badge ? '<span class="cfc__badge mono">' + esc(x.badge) + '</span>' : '') +
      (x.col ? '<span class="cfc__cbadge"><span class="cfc__dot" style="' + dotStyle(x.col) + '"></span>' + esc(x.col) + '</span>' : '') + '</a>' +
      '<div class="cfc__cb"><p class="cfc__kind mono">' + esc(x.kindL) + (x.sub2 && x.sub2 !== x.kindL ? ' · ' + esc(x.sub2) : '') + '</p>' +
      '<h3><a href="' + esc(x.u) + '">' + esc(x.t) + '</a></h3>' +
      (x.spec.length ? '<dl class="cfc__spec">' + x.spec.map(function (s) { return '<dt>' + esc(s[0]) + '</dt><dd>' + esc(s[1] || '—') + '</dd>'; }).join('') + '</dl>' : '') +
      '<div class="cfc__buy"><strong class="cfc__price">' + money(x.p) + '</strong>' +
      (x.a ? '<div class="cfc__row"><div class="cfc__qty" role="group" aria-label="Quantity"><button type="button" data-dec="' + x.i + '" aria-label="Decrease quantity">−</button><span class="mono">' + q + '</span><button type="button" data-inc="' + x.i + '" aria-label="Increase quantity">+</button></div><button type="button" class="cfc__add" data-add="' + x.i + '">Add</button></div>'
        : '<div class="cfc__row"><button type="button" class="cfc__add" disabled>Sold out</button></div>') +
      '</div></div></article>';
  }

  function table(list) {
    return '<table class="cfc__tbl"><thead><tr><th scope="col">Size</th><th scope="col">Product</th><th scope="col">Type</th>' +
      TBL_H.map(function (h) { return '<th scope="col">' + esc(h) + '</th>'; }).join('') +
      '<th scope="col" class="r">Price</th><th scope="col"><span class="sr">Add</span></th></tr></thead><tbody>' +
      list.map(function (x) {
        return '<tr><td class="mono b">' + esc(x.badge || '—') + '</td><td class="t"><a href="' + esc(x.u) + '">' + esc(x.t) + '</a></td><td>' + esc(x.kindL) + '</td>' +
          x.tbl.map(function (v) { return '<td class="mono">' + esc(v || '—') + '</td>'; }).join('') +
          '<td class="r b">' + money(x.p) + '</td><td>' + (x.a ? '<button type="button" class="cfc__add" data-add="' + x.i + '" aria-label="Add ' + esc(x.t) + ' to basket">Add</button>' : '<span class="cfc__so">Sold out</span>') + '</td></tr>';
      }).join('') + '</tbody></table>';
  }

  function updateTiles() {
    if (!IS_DEPT) return;
    var base = P.filter(function (x) { return pass(x, 'kind'); });
    $$('.cfc__tile').forEach(function (a) {
      var sub = a.getAttribute('data-sub'), k = sub ? SUB2KIND[sub] : '';
      var arr = k ? base.filter(function (x) { return x.k === k; }) : base;
      var tc = $('[data-tc]', a), tp = $('[data-tp]', a);
      if (tc) tc.textContent = arr.length;
      if (tp) tp.textContent = arr.length ? money(Math.min.apply(null, arr.map(function (x) { return x.p; }))) : '—';
      var on = (k || '') === S.kind;
      a.classList.toggle('on', on);
      if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
  }

  function render() {
    renderBar();
    renderFacets();
    updateTiles();
    var list = P.filter(function (x) { return pass(x); });
    if (S.sort === 'size') list.sort(function (a, b) { return (a.sort - b.sort) || (a.sort2 - b.sort2) || (a.p - b.p); });
    else if (S.sort === 'plo') list.sort(function (a, b) { return a.p - b.p; });
    else list.sort(function (a, b) { return b.p - a.p; });
    var vis = list.slice(0, S.shown);
    $('[data-total]').textContent = list.length;
    $('[data-unit]').textContent = list.length === 1 ? UNIT[0] : UNIT[1];
    var c = chips();
    var ch = $('[data-chips]');
    ch.hidden = !c.length;
    ch.innerHTML = c.map(function (z) { return '<button type="button" class="cfc__chip" data-rm="' + z[0] + '" data-rv="' + esc(z[1]) + '" aria-label="Remove filter ' + esc(z[2]) + '">' + esc(z[2]) + ' <span aria-hidden="true">×</span></button>'; }).join('') + (c.length ? '<button type="button" class="cfc__chipclear" data-clear>Clear all</button>' : '');
    $$('[data-clear]').forEach(function (b) { if (b.closest('.cfc__sidehead')) b.hidden = !c.length; });
    $('[data-active-n]').textContent = c.length ? c.length : '';
    $$('[data-sort]').forEach(function (b) { var on = b.getAttribute('data-sort') === S.sort; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on); });
    $$('[data-view]').forEach(function (b) { var on = b.getAttribute('data-view') === S.view; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on); });
    var g = $('[data-grid]'), tb = $('[data-table]'), em = $('[data-empty]');
    em.hidden = list.length > 0;
    g.hidden = !(S.view === 'grid' && list.length);
    tb.hidden = !(S.view === 'table' && list.length);
    if (!g.hidden) g.innerHTML = vis.map(card).join('');
    if (!tb.hidden) tb.innerHTML = table(vis);
    var more = $('[data-more]');
    more.hidden = vis.length >= list.length;
    if (!more.hidden) {
      $('[data-showing]').textContent = 'Showing ' + vis.length + ' of ' + list.length;
      $('[data-prog]').style.width = Math.round(vis.length / list.length * 100) + '%';
      $('[data-more-btn]').textContent = 'Show ' + Math.min(PAGE, list.length - vis.length) + ' more';
    }
    var side = $('[data-side]');
    side.classList.toggle('open', S.side);
    $('[data-toggle-side]').setAttribute('aria-expanded', S.side);
  }
  function reset() { S.shown = PAGE; }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('button, a[data-sub], a.cfc__tile, a[data-guide]');
    if (!b || !root.contains(b)) return;
    if (b.matches('a.cfc__tile') && IS_DEPT) {
      e.preventDefault();
      var sub = b.getAttribute('data-sub');
      S.kind = sub ? (SUB2KIND[sub] || '') : '';
      reset(); render(); return;
    }
    if (b.hasAttribute('data-guide') && IS_DEPT && SUB2KIND[b.getAttribute('data-guide')]) {
      e.preventDefault();
      S.kind = SUB2KIND[b.getAttribute('data-guide')]; reset(); render();
      $('.cfc__list').scrollIntoView({ behavior: 'smooth', block: 'start' }); return;
    }
    if (b.tagName === 'A') return;
    if (b.hasAttribute('data-std')) { S.std = b.getAttribute('data-std'); S.size = 0; reset(); render(); return; }
    if (b.hasAttribute('data-size')) { var v = +b.getAttribute('data-size'); S.size = S.size === v ? 0 : v; reset(); render(); return; }
    if (b.hasAttribute('data-fk')) { var k = b.getAttribute('data-fk'), fv = b.getAttribute('data-fv'); if (S.f[k][fv]) delete S.f[k][fv]; else S.f[k][fv] = 1; reset(); render(); return; }
    if (b.hasAttribute('data-rm')) {
      var rm = b.getAttribute('data-rm'), rv = b.getAttribute('data-rv');
      if (rm === 'kind') S.kind = ''; else if (rm === 'std') { S.std = ''; S.size = 0; } else if (rm === 'size') S.size = 0; else delete S.f[rm][rv];
      reset(); render(); return;
    }
    if (b.hasAttribute('data-clear')) { S.kind = ''; S.std = ''; S.size = 0; S.f = { cls: {}, mat: {}, col: {}, len: {}, band: {} }; reset(); render(); return; }
    if (b.hasAttribute('data-sort')) { S.sort = b.getAttribute('data-sort'); render(); return; }
    if (b.hasAttribute('data-view')) { S.view = b.getAttribute('data-view'); render(); return; }
    if (b.hasAttribute('data-more-btn')) { S.shown += PAGE; render(); return; }
    if (b.hasAttribute('data-toggle-side')) { S.side = !S.side; render(); return; }
    if (b.hasAttribute('data-inc') || b.hasAttribute('data-dec')) {
      var ii = +(b.getAttribute('data-inc') || b.getAttribute('data-dec'));
      var q = (S.q[ii] || 1) + (b.hasAttribute('data-inc') ? 1 : -1);
      S.q[ii] = Math.max(1, Math.min(999, q));
      var span = b.parentNode.querySelector('span'); if (span) span.textContent = S.q[ii];
      return;
    }
    if (b.hasAttribute('data-add')) { add(b, P[+b.getAttribute('data-add')]); }
  });

  var bar = $('[data-added]');
  function add(btn, x) {
    if (!x) return;
    var qty = S.q[x.i] || 1;
    btn.disabled = true;
    fetch(ROOT_URL + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: x.id, quantity: qty }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch(ROOT_URL + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        if (window.cfSetCartCount) window.cfSetCartCount(cart.item_count);
        bar.classList.remove('err');
        bar.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FFC21A" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg><span>Added to basket: <strong>' + qty + ' × ' + esc(x.t) + '</strong></span><a href="' + ROOT_URL + 'cart">View basket</a>';
        bar.hidden = false;
      })
      .catch(function (err) {
        bar.classList.add('err');
        bar.innerHTML = '<span>' + esc((err && (err.description || err.message)) || 'Could not add that item. Please try again.') + '</span>';
        bar.hidden = false;
      })
      .then(function () { btn.disabled = false; });
  }

  /* ---------- large collections: fetch remaining pages ---------- */
  function loadRest() {
    if (!COL.count || RAW.length >= COL.count || !COL.url) return Promise.resolve();
    var pages = [], start = Math.floor(RAW.length / 250) + 1;
    for (var pg = start; pg <= Math.ceil(COL.count / 250); pg++) pages.push(pg);
    return Promise.all(pages.map(function (pg) { return fetch(COL.url + '/products.json?limit=250&page=' + pg).then(function (r) { return r.json(); }); }))
      .then(function (res) {
        var seen = {}; RAW.forEach(function (r) { seen[r[5]] = 1; });
        res.forEach(function (j) {
          (j.products || []).forEach(function (p) {
            var u = ROOT_URL + 'products/' + p.handle; if (seen[u]) return;
            var v = p.variants[0] || {};
            var img = p.images && p.images[0] ? p.images[0].src + (p.images[0].src.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
            RAW.push([p.title, p.product_type, v.id, Math.round(parseFloat(v.price) * 100), !!v.available, u, img]);
          });
        });
        build();
      }).catch(function () {});
  }

  render();
  loadRest().then(function () { if (RAW.length !== P.length || COL.count > 250) render(); });
})();
